import React, { useEffect } from 'react';
import styles from './SalesforceHome.module.css';
import SalesforceLogo from 'assets/images/salesforce-logo.png';
import { useNavigate } from 'react-router-dom';

interface SalesforceHomeProps {
  skipValidation?: boolean;
}

export default function SalesforceHome({ skipValidation }: SalesforceHomeProps) {
  const navigate = useNavigate();
  useEffect(() => {
    if (skipValidation) {
      return;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (!urlParams.has('token')) {
      navigate('/login', { replace: true });
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.cardContainer}>
        <img src={SalesforceLogo} className={styles.logo} alt='Saleforce logo' />
        <p className={styles.fontStyles}>✅ Login Successful</p>
        <p className={styles.subtitleStyles}>
          You&apos;re now logged in. You can close this window and carry on with your tasks.
        </p>
      </div>
    </div>
  );
}
